const routes = [
  {
    path: '/dept',
    name: 'dept',
    component: () => import('@src/modules/dept/view/index'),
    meta: {
      requireAuth: false,
      routerAlive: false
    }
  }
]

export default routes
